import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useForm } from "react-hook-form";
import { loginAPI } from "../APIs/API";
import { setToken } from "../utils/utils";
import { MyContext } from "../MyContext/MyProvider";

const Login = () => {
  console.log("hello")
  const [showPassword, setShowPassword] = useState(false);
  const { setIsLoading } = useContext(MyContext);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  console.log("hello")
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    const { rememberMe, ...rest } = data;

    try {
      const res = await loginAPI(rest);
      if (res) {
        setToken(res.token, data.email, res.role);
        window.location.href = "/dashboard/fileupload";
      }
    } catch (error) {
      // console.log(error);
      if (error.message === "Your account is not approved yet!") {
        window.location.href = "/pending-approval";
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="login-main-container h-center v-center">
        <div className="login-container w-100">
          <div className="input-form-main w-100">
            <h3 className="text-medium-black fw-semibold large text-center text-sm-start">
              Log In
            </h3>
            <form
              className="input-form h-center flex-column"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="mt-50 h-center flex-column gap-12">
                <label className="large fw-normal text-medium-black">
                  Email address
                </label>
                <input
                  {...register("email", {
                    required: "Email is required",
                    maxLength: {
                      value: 30,
                      message: "Must not be more than 30 characters",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
                      message: "Invalid email address",
                    },
                  })}
                  type="email"
                  inputMode="email"
                  className="form-input"
                  placeholder="Enter your Email"
                  // required
                />{" "}
                {/* {errors.email && (
                  <span className="error">{errors.email.message}</span>
                )} */}
              </div>
              <div className="mt-24 d-flex flex-column gap-12">
                <label className="large fw-normal text-medium-black">
                  Password
                </label>
                <div className="input-password">
                  <input
                    {...register("password", {
                      required: "Password is required",
                      // minLength: {
                      //   value: 10,
                      //   message: "Must be at least 10 characters long",
                      // },
                      // pattern: {
                      //   value: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
                      //   message:
                      //     "Must contain at least one uppercase letter, one special character, and one digit",
                      // },
                    })}
                    type={showPassword ? "text" : "password"}
                    inputMode="text"
                    className="form-input pswd-feild"
                    placeholder="*****"
                    // required
                  />
                  <Icon
                    icon={showPassword ? "fa-solid:eye" : "fa6-solid:eye-slash"}
                    className="eye-icon"
                    onClick={togglePasswordVisibility}
                    color="#000000"
                  />
                </div>
                {/* {errors.password && (
                  <span className="error">{errors.password.message}</span>
                )} */}
              </div>
              {/* <p className="text-light-black pt-1">
                Use 8 or more characters with a mix of letters, numbers &
                symbols
              </p> */}
              <div className="forget-pswd-div text-dark-black fw-normal d-flex space-between">
                <Link to="/forgetpassword">
                  <label className="text-underline large link text-dark-black">
                    Forget your password?
                  </label>
                </Link>
              </div>
              <div className="bottom-btn-div mt-5 pt-3">
                <button className="btn-primary" type="submit">
                  Login
                </button>
                <div className="mt-3">
                  <label className="small fw-normal h-center v-center gap-1 text-black">
                    Doesn’t have an account?
                    <Link to="/signup">
                      <label className="text-red link">Create Account</label>
                    </Link>
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
